<header class="top_header" *ngIf="isMenucompangin==false">
  <div class="main_logos">
      <div class="logo">
          <img src="{{logoUrl}}" alt="Company Logo" class="image"  />
      </div>
  </div>
  <nav *ngIf="isMenu">
      <ul>
          <li class="drop1">
              <div>
                  <!-- <button mat-icon-button *ngIf="!isSearch||deviceXs" (click)="Search()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </button> -->
              </div>
          </li>
          <li *ngIf="isSearch&&!deviceXs">
              <div>
                <div class="input-icons">
                    <div class="input-container">
                      <!-- <input class="input-field custom-input" type="text" placeholder="{{searchText}}..." #menuInput autofocus matInput [matAutocomplete]="auto" [(ngModel)]="searchOption" (keyup)="search()">
                      <span (click)="Search()" class="icon-container">
                        <i class="fa fa-times-circle-o pointer" aria-hidden="true" *ngIf="isSearch && !deviceXs"></i>
                      </span> -->
                    </div>
                    <mat-autocomplete #auto="matAutocomplete" class="mt-2">
                      <mat-option *ngFor="let item of getSearchOption" [value]="item.title" (click)="viewPage(item.objectID,item.objectTypeID)">
                        <span>
                          <!-- <span *ngIf="item.objectTypeID===101"><i class="fa fa-handshake-o drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===102"><i class="fa fa-lightbulb-o drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===103"><i class="fa fa-exclamation-triangle drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===104"><i class="fa fa-file-archive-o drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===105"><i class="fa fa-object-group drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===106"><i class="fa fa-street-view drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===107"><i class="fa fa-comments-o drop_downicons mx-1" aria-hidden="true"></i></span>
                          <span *ngIf="item.objectTypeID===108"><i class="fa-hand-paper far drop_downicons mx-1" aria-hidden="true"></i></span>
                          {{item.title}} -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  
              </div>
          </li>
          <!-- <li class="drop2">
              <div ngbDropdown>
                  <button mat-icon-button ngbDropdownToggle>
                      <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  </button>
                  <div ngbDropdownMenu="gfg" class="" *ngIf="createMenu.length>1">
                      <div *ngFor="let m of createMenu" class="dropdown-content dropdownCon pointer" ngbDropdownItem (click)="setObjectDynamic(m, m.url)">
                        <p><i class="{{m.iconClass}}" [ngClass]="m.isEnabled===true?'drop_downicons':'drop_nonliveIcons'" aria-hidden="true"></i> {{m.functionalityName}}</p>
                    </div>
                  </div>
              </div>
          </li> -->
          <!-- <li class="drop3">
              <div ngbDropdown>
                  <button mat-icon-button ngbDropdownToggle>
                      <i class="fa fa-th" aria-hidden="true"></i>
                  </button>
                  <div ngbDropdownMenu="gfg">
                      <div class="dropdown-content text-center" ngbDropdownItem>
                          <app-side-nav [deviceXs]="deviceXs" [menuArray]="menuArray"></app-side-nav>
                      </div>
                      <div class="org_seetings border_top" ngbDropdownItem style="cursor: pointer;" (click)="navigateToMenulist(m.sWAFunctionalityID)" *ngFor="let m of viewMenu">
                        <span><i class="{{m.iconClass}}" aria-hidden="true"></i> <a>{{m.functionalityName}}</a></span>
                      </div>
                  </div>
              </div>
          </li> -->
          <!-- <li class="drop4">
              <div ngbDropdown>
                  <button mat-icon-button ngbDropdownToggle>
                      <i class="fa fa-user" aria-hidden="true"></i>
                  </button>
                  <div ngbDropdownMenu="gfg">
                      <div class="dropdown-content" ngbDropdownItem>
                          <div class="d-flex justify-content-space">
                              <div class="profile-img1">
                                <img *ngIf="profileImg" [src]="profileImg" (error)="handleImageError(profileImg)" class="main_user" alt="profile">
                                <img *ngIf="!profileImg" src="../../../assets/images/users.png" class="main_user" alt="profile">
                              </div>
                              <span class="d-block small mx-1">
                                  <p class="mb-0 switch-label" style="margin-top: 4px;">{{firstName}} </p>
                                  <p class="mb-0">{{userDetails?.roleName}}</p>
                                  <p class="mb-0">{{userDetails?.orgName}}</p>
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
          </li> -->
          <!-- <li>

              <div (click)="logout()" class="pointer">
                  <button mat-icon-button>
                      <i class="fa fa-power-off" aria-hidden="true"></i>
                  </button>
              </div>
          </li> -->
      </ul>
  </nav>
</header>
<div class="" *ngIf="isSearch&&deviceXs">
  <div class="inputBox1">
      <div class="input-icons">
          <!-- <input class="input-field" type="text" placeholder="{{searchText}}..." autofocus #menuInput matInput [matAutocomplete]="auto" [(ngModel)]="searchOption" (keyup)="search()">
          <span (click)="Search()">
              <i class="fa fa-times-circle-o mx-1 pointer" aria-hidden="true"></i>
          </span>
          <mat-autocomplete #auto="matAutocomplete" class="mt-2">
              <mat-option *ngFor="let item of getSearchOption" [value]="item.title" (click)="viewPage(item.objectID,item.objectTypeID)">
                  <span><span *ngIf="item.objectTypeID===101"><i class="fa fa-handshake-o drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===102"><i class="fa fa-lightbulb-o drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===103"><i class="fa fa-exclamation-triangle drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===104"><i class="fa fa-file-archive-o drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===105"><i class="fa fa-object-group drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===106"><i class="fa fa-street-view drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===107"><i class="fa fa-comments-o drop_downicons mx-1" aria-hidden="true"></i></span>
                  <span *ngIf="item.objectTypeID===108"><i class="fa-hand-paper far drop_downicons mx-1" aria-hidden="true"></i></span>{{item.title}}</span>
              </mat-option>
          </mat-autocomplete> -->
      </div>
  </div>
</div>